import { styled } from '@porsche-code/kado-styled-system/jsx';
import { Modal } from '@porsche-code/kado-ui';
import { PIcon, PLinkPure } from '@porsche-design-system/components-react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { hasPorscheDesignSystemBrowserSupport } from '@/helpers';

const Content = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 'md',
  },
});

export const BrowserSupport = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(true);

  if (hasPorscheDesignSystemBrowserSupport()) {
    return null;
  }

  return (
    <Modal
      open={isModalOpen}
      onDismiss={() => setIsModalOpen(false)}
      backdrop="shading"
    >
      <Modal.Header align="center">{t('browserSupport.title')}</Modal.Header>

      <Content>
        <PIcon name="warning" color="warning" size="5xl" />

        <div>
          <Trans i18nKey="browserSupport.content">
            The browser you are using is no longer supported. It would be best
            to directly switch to the latest version of{' '}
            <PLinkPure
              icon="none"
              href="https://google.com/chrome/"
              target="_blank"
              rel="nofollow noopener"
              underline
            >
              Google Chrome
            </PLinkPure>
            ,
            <PLinkPure
              icon="none"
              href="https://mozilla.org/firefox/new/"
              target="_blank"
              rel="nofollow noopener"
              underline
            >
              Mozilla Firefox
            </PLinkPure>
            or
            <PLinkPure
              icon="none"
              href="https://microsoft.com/edge/"
              target="_blank"
              rel="nofollow noopener"
              underline
            >
              Microsoft Edge
            </PLinkPure>
            .
          </Trans>
        </div>
      </Content>
    </Modal>
  );
};
